const icons = {};

icons.shopper = (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="300.000000pt"
    height="300.000000pt"
    viewBox="0 0 300.000000 300.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M982 2450 c-109 -29 -187 -74 -272 -160 -87 -86 -131 -163 -160 -276
    -19 -73 -20 -113 -20 -781 l0 -703 703 0 c668 0 708 1 781 20 113 29 190 73
    276 160 87 86 131 163 160 276 19 73 20 113 20 781 l0 703 -707 -1 c-664 0
    -713 -1 -781 -19z m1278 -158 c14 -10 34 -36 44 -57 17 -35 18 -42 5 -79 -17
    -50 -67 -86 -118 -86 -97 1 -152 104 -101 188 37 60 113 75 170 34z m-550
    -284 c64 -20 160 -64 160 -73 0 -6 -121 -195 -125 -195 -2 0 -32 13 -67 30
    -119 56 -258 32 -258 -45 0 -33 28 -50 172 -101 227 -81 307 -163 307 -319 1
    -155 -125 -273 -326 -305 -111 -18 -274 12 -383 71 -104 56 -102 45 -30 154
    34 52 65 95 68 95 3 0 26 -13 51 -29 121 -77 303 -82 341 -11 28 52 -21 92
    -180 149 -221 81 -292 153 -292 298 -1 231 276 368 562 281z"
      />
    </g>
  </svg>
);
icons.select_ok = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" fill="#F5F5F5" />
    <path
      d="M-5296 -3654C-5296 -3655.1 -5295.1 -3656 -5294 -3656H3119C3120.1 -3656 3121 -3655.1 3121 -3654V3668C3121 3669.1 3120.1 3670 3119 3670H-5294C-5295.1 3670 -5296 3669.1 -5296 3668V-3654Z"
      fill="#EFF0F4"
    />
    <g clip-path="url(#clip0_0_1)">
      <rect x="-24" y="-20" width="1210" height="712" rx="20" fill="white" />
      <g filter="url(#filter0_d_0_1)">
        <rect
          width="1210"
          height="72"
          transform="translate(-24 -20)"
          fill="#FFF1EA"
        />
        <circle cx="16" cy="16" r="16" fill="#F25522" />
        <g clip-path="url(#clip1_0_1)">
          <path
            d="M13.5026 19.5001L10.0026 16.0001L8.83594 17.1667L13.5026 21.8334L23.5026 11.8334L22.3359 10.6667L13.5026 19.5001Z"
            fill="white"
          />
        </g>
      </g>
    </g>
    <path
      d="M-5294 -3655H3119V-3657H-5294V-3655ZM3120 -3654V3668H3122V-3654H3120ZM3119 3669H-5294V3671H3119V3669ZM-5295 3668V-3654H-5297V3668H-5295ZM-5294 3669C-5294.55 3669 -5295 3668.55 -5295 3668H-5297C-5297 3669.66 -5295.66 3671 -5294 3671V3669ZM3120 3668C3120 3668.55 3119.55 3669 3119 3669V3671C3120.66 3671 3122 3669.66 3122 3668H3120ZM3119 -3655C3119.55 -3655 3120 -3654.55 3120 -3654H3122C3122 -3655.66 3120.66 -3657 3119 -3657V-3655ZM-5294 -3657C-5295.66 -3657 -5297 -3655.66 -5297 -3654H-5295C-5295 -3654.55 -5294.55 -3655 -5294 -3655V-3657Z"
      fill="black"
      fill-opacity="0.1"
    />
    <defs>
      <filter
        id="filter0_d_0_1"
        x="-28"
        y="-23"
        width="1218"
        height="80"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_0_1"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_0_1"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_0_1">
        <rect x="-24" y="-20" width="1210" height="712" rx="20" fill="white" />
      </clipPath>
      <clipPath id="clip1_0_1">
        <rect width="20" height="20" fill="white" transform="translate(6 6)" />
      </clipPath>
    </defs>
  </svg>
);
icons.unselected_round_grey = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="11" stroke="#878792" stroke-width="10" />
  </svg>
);
icons.select_round_orange = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" fill="#F5F5F5" />
    <path
      d="M-5724 -3654C-5724 -3655.1 -5723.1 -3656 -5722 -3656H2691C2692.1 -3656 2693 -3655.1 2693 -3654V3668C2693 3669.1 2692.1 3670 2691 3670H-5722C-5723.1 3670 -5724 3669.1 -5724 3668V-3654Z"
      fill="#EFF0F4"
    />
    <g clip-path="url(#clip0_0_1)">
      <rect x="-452" y="-20" width="1210" height="712" rx="20" fill="white" />
      <g filter="url(#filter0_d_0_1)">
        <rect
          width="1210"
          height="72"
          transform="translate(-452 -20)"
          fill="#FFF1EA"
        />
        <circle cx="16" cy="16" r="11" stroke="#F25522" stroke-width="10" />
      </g>
    </g>
    <path
      d="M-5722 -3655H2691V-3657H-5722V-3655ZM2692 -3654V3668H2694V-3654H2692ZM2691 3669H-5722V3671H2691V3669ZM-5723 3668V-3654H-5725V3668H-5723ZM-5722 3669C-5722.55 3669 -5723 3668.55 -5723 3668H-5725C-5725 3669.66 -5723.66 3671 -5722 3671V3669ZM2692 3668C2692 3668.55 2691.55 3669 2691 3669V3671C2692.66 3671 2694 3669.66 2694 3668H2692ZM2691 -3655C2691.55 -3655 2692 -3654.55 2692 -3654H2694C2694 -3655.66 2692.66 -3657 2691 -3657V-3655ZM-5722 -3657C-5723.66 -3657 -5725 -3655.66 -5725 -3654H-5723C-5723 -3654.55 -5722.55 -3655 -5722 -3655V-3657Z"
      fill="black"
      fill-opacity="0.1"
    />
    <defs>
      <filter
        id="filter0_d_0_1"
        x="-456"
        y="-23"
        width="1218"
        height="80"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_0_1"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_0_1"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_0_1">
        <rect x="-452" y="-20" width="1210" height="712" rx="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
icons.close = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" fill="#F5F5F5" />
    <path
      d="M-6434 -3658C-6434 -3659.1 -6433.1 -3660 -6432 -3660H1981C1982.1 -3660 1983 -3659.1 1983 -3658V3664C1983 3665.1 1982.1 3666 1981 3666H-6432C-6433.1 3666 -6434 3665.1 -6434 3664V-3658Z"
      fill="#EFF0F4"
    />
    <g clip-path="url(#clip0_0_1)">
      <rect x="-1162" y="-24" width="1210" height="712" rx="20" fill="white" />
      <g filter="url(#filter0_d_0_1)">
        <rect
          width="1210"
          height="72"
          transform="translate(-1162 -24)"
          fill="#FFF1EA"
        />
        <circle
          cx="12"
          cy="12"
          r="11.625"
          stroke="#3F3F46"
          stroke-width="0.75"
        />
        <path
          d="M17 8.00714L15.9929 7L12 10.9929L8.00714 7L7 8.00714L10.9929 12L7 15.9929L8.00714 17L12 13.0071L15.9929 17L17 15.9929L13.0071 12L17 8.00714Z"
          fill="#3F3F46"
        />
      </g>
    </g>
    <path
      d="M-6432 -3659H1981V-3661H-6432V-3659ZM1982 -3658V3664H1984V-3658H1982ZM1981 3665H-6432V3667H1981V3665ZM-6433 3664V-3658H-6435V3664H-6433ZM-6432 3665C-6432.55 3665 -6433 3664.55 -6433 3664H-6435C-6435 3665.66 -6433.66 3667 -6432 3667V3665ZM1982 3664C1982 3664.55 1981.55 3665 1981 3665V3667C1982.66 3667 1984 3665.66 1984 3664H1982ZM1981 -3659C1981.55 -3659 1982 -3658.55 1982 -3658H1984C1984 -3659.66 1982.66 -3661 1981 -3661V-3659ZM-6432 -3661C-6433.66 -3661 -6435 -3659.66 -6435 -3658H-6433C-6433 -3658.55 -6432.55 -3659 -6432 -3659V-3661Z"
      fill="black"
      fill-opacity="0.1"
    />
    <defs>
      <filter
        id="filter0_d_0_1"
        x="-1166"
        y="-27"
        width="1218"
        height="80"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_0_1"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_0_1"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_0_1">
        <rect
          x="-1162"
          y="-24"
          width="1210"
          height="712"
          rx="20"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
icons.search = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.7761 14.5654L14.5608 14.7807C14.2623 15.0792 13.7782 15.0792 13.4797 14.7807L10.1915 11.4468C9.22701 12.1528 8.04014 12.5723 6.7531 12.5657C3.5592 12.5492 0.983594 9.94648 1.00008 6.75284C1.01656 3.55895 3.61905 0.983343 6.81295 1.00008C10.0068 1.01682 12.5825 3.61905 12.5657 6.81295C12.5594 8.05764 12.1564 9.20545 11.4823 10.1456L14.7761 13.4848C15.0746 13.7828 15.0746 14.2669 14.7761 14.5654ZM6.78302 2.81563C4.59213 2.81563 2.81614 4.59163 2.81614 6.78251C2.81614 8.9734 4.59213 10.7494 6.78302 10.7494C8.97391 10.7494 10.7499 8.9734 10.7499 6.78251C10.7497 4.59163 8.97366 2.81563 6.78302 2.81563Z"
      fill="#878792"
    ></path>
  </svg>
);
icons.leftArrow = (
  <svg
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0776 5.5L7.57764 11.1571L12.7721 16.5"
      stroke="#222222"
      stroke-width="2.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
  </svg>
);
icons.rightArrow = (
  <svg
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.57764 5.5L15.0776 11.1571L9.88319 16.5"
      stroke="#222222"
      stroke-width="2.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
  </svg>
);
icons.embeddedWidgetIcon = (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.25 15.168C3.45435 15.168 2.69129 14.8519 2.12868 14.2893C1.56607 13.7267 1.25 12.9636 1.25 12.168V3.16797C1.25 2.77014 1.40804 2.38861 1.68934 2.10731C1.97064 1.826 2.35218 1.66797 2.75 1.66797H5.75C6.14782 1.66797 6.52936 1.826 6.81066 2.10731C7.09196 2.38861 7.25 2.77014 7.25 3.16797V12.168C7.25 12.9636 6.93393 13.7267 6.37132 14.2893M4.25 15.168C5.04565 15.168 5.80871 14.8519 6.37132 14.2893M4.25 15.168H13.25C13.6478 15.168 14.0294 15.0099 14.3107 14.7286C14.592 14.4473 14.75 14.0658 14.75 13.668V10.668C14.75 10.2701 14.592 9.88861 14.3107 9.60731C14.0294 9.326 13.6478 9.16797 13.25 9.16797H11.4927M6.37132 14.2893L12.7355 7.92522C13.0167 7.64393 13.1747 7.26246 13.1747 6.86472C13.1747 6.46697 13.0167 6.08551 12.7355 5.80422L10.6137 3.68247C10.3325 3.40126 9.951 3.24329 9.55325 3.24329C9.1555 3.24329 8.77404 3.40126 8.49275 3.68247L7.25 4.92522M4.25 12.168H4.2575"
      stroke="#64748B"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
icons.prodnameSettingsIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.25 7.25H2.75M13.25 7.25C13.6478 7.25 14.0294 7.40804 14.3107 7.68934C14.592 7.97064 14.75 8.35218 14.75 8.75V13.25C14.75 13.6478 14.592 14.0294 14.3107 14.3107C14.0294 14.592 13.6478 14.75 13.25 14.75H2.75C2.35218 14.75 1.97064 14.592 1.68934 14.3107C1.40804 14.0294 1.25 13.6478 1.25 13.25V8.75C1.25 8.35218 1.40804 7.97064 1.68934 7.68934C1.97064 7.40804 2.35218 7.25 2.75 7.25M13.25 7.25V5.75C13.25 5.35218 13.092 4.97064 12.8107 4.68934C12.5294 4.40804 12.1478 4.25 11.75 4.25M2.75 7.25V5.75C2.75 5.35218 2.90804 4.97064 3.18934 4.68934C3.47064 4.40804 3.85218 4.25 4.25 4.25M11.75 4.25V2.75C11.75 2.35218 11.592 1.97064 11.3107 1.68934C11.0294 1.40804 10.6478 1.25 10.25 1.25H5.75C5.35218 1.25 4.97064 1.40804 4.68934 1.68934C4.40804 1.97064 4.25 2.35218 4.25 2.75V4.25M11.75 4.25H4.25"
      stroke="#71717A"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
icons.widgetTypeicon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.21967 1.21967C1.07902 1.36032 1 1.55109 1 1.75V3.25C1 3.44891 1.07902 3.63968 1.21967 3.78033C1.36032 3.92098 1.55109 4 1.75 4H12.25C12.4489 4 12.6397 3.92098 12.7803 3.78033C12.921 3.63968 13 3.44891 13 3.25V1.75C13 1.55109 12.921 1.36032 12.7803 1.21967C12.6397 1.07902 12.4489 1 12.25 1H1.75C1.55109 1 1.36032 1.07902 1.21967 1.21967Z"
      stroke="#64748B"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.21967 7.21967C1.07902 7.36032 1 7.55109 1 7.75V12.25C1 12.4489 1.07902 12.6397 1.21967 12.7803C1.36032 12.921 1.55109 13 1.75 13H6.25C6.44891 13 6.63968 12.921 6.78033 12.7803C6.92098 12.6397 7 12.4489 7 12.25V7.75C7 7.55109 6.92098 7.36032 6.78033 7.21967C6.63968 7.07902 6.44891 7 6.25 7H1.75C1.55109 7 1.36032 7.07902 1.21967 7.21967Z"
      stroke="#64748B"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.2197 7.21967C10.079 7.36032 10 7.55109 10 7.75V12.25C10 12.4489 10.079 12.6397 10.2197 12.7803C10.3603 12.921 10.5511 13 10.75 13H12.25C12.4489 13 12.6397 12.921 12.7803 12.7803C12.921 12.6397 13 12.4489 13 12.25V7.75C13 7.55109 12.921 7.36032 12.7803 7.21967C12.6397 7.07902 12.4489 7 12.25 7H10.75C10.5511 7 10.3603 7.07902 10.2197 7.21967Z"
      stroke="#64748B"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
icons.singleDisplay = (
  <svg viewBox="0 0 89 63" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="83" height="57" rx="5.34091" fill="white" />
    <rect
      x="16.3516"
      y="12.3467"
      width="57.4148"
      height="25.3693"
      rx="2.67045"
      fill="#F25225"
    />
    <rect
      x="16.3516"
      y="43.0566"
      width="36.0511"
      height="8.01136"
      rx="2.67045"
      fill="#F25225"
    />
    <rect
      x="3"
      y="3"
      width="83"
      height="57"
      rx="5.34091"
      stroke="#F25225"
      stroke-width="5"
    />
  </svg>
);
icons.buttonDisplay = (
  <svg viewBox="0 0 89 43" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="3"
      y="3"
      width="83.0005"
      height="37.1644"
      rx="4.95525"
      fill="white"
    />
    <rect
      x="27.7734"
      y="17.8657"
      width="33.448"
      height="7.43288"
      rx="2.47763"
      fill="#F25225"
    />
    <rect
      x="3"
      y="3"
      width="83.0005"
      height="37.1644"
      rx="4.95525"
      stroke="#F25225"
      stroke-width="5"
    />
  </svg>
);
icons.imageDisplay = (
  <svg viewBox="0 0 89 63" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="83" height="57" rx="6.03636" fill="white" />
    <rect
      width="83"
      height="25"
      rx="3.01818"
      transform="matrix(1 0 0 -1 3 60)"
      fill="#F25225"
    />
    <circle cx="67.8905" cy="19.6" r="9.05455" fill="#F25225" />
    <rect
      x="3"
      y="3"
      width="83"
      height="57"
      rx="6.03636"
      stroke="#F25225"
      stroke-width="5"
    />
  </svg>
);
icons.verticalDisplay = (
  <svg
    width="91"
    height="85"
    viewBox="0 0 91 85"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3.73438"
      y="12.1406"
      width="38.2967"
      height="61.6483"
      rx="4.98876"
      fill="white"
    />
    <rect x="9" y="21" width="28" height="29" rx="2.49438" fill="#F25225" />
    <rect x="9" y="56" width="20" height="7" rx="2.49438" fill="#F25225" />
    <rect
      x="3.73438"
      y="12.1406"
      width="38.2967"
      height="61.6483"
      rx="4.98876"
      stroke="#F25225"
      stroke-width="4.67033"
    />
    <rect
      x="49.5078"
      y="12.1406"
      width="38.2967"
      height="61.6483"
      rx="4.98876"
      fill="white"
    />
    <rect x="55" y="21" width="28" height="29" rx="2.49438" fill="#F25225" />
    <rect x="55" y="56" width="20" height="7" rx="2.49438" fill="#F25225" />
    <rect
      x="49.5078"
      y="12.1406"
      width="38.2967"
      height="61.6483"
      rx="4.98876"
      stroke="#F25225"
      stroke-width="4.67033"
    />
  </svg>
);
icons.horizontalDisplay = (
  <svg
    width="91"
    height="85"
    viewBox="0 0 91 85"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1736_10613)">
      <rect x="3" y="3" width="84" height="36" rx="4.98876" fill="white" />
      <rect
        x="10"
        y="9"
        width="30.7344"
        height="23"
        rx="2.49438"
        fill="#F25225"
      />
      <rect
        x="47"
        y="25"
        width="27.68"
        height="7"
        rx="2.49438"
        fill="#F25225"
      />
      <rect x="47" y="9" width="33" height="10" rx="2.49438" fill="#F25225" />
      <rect
        x="3"
        y="3"
        width="84"
        height="36"
        rx="4.98876"
        stroke="#F25225"
        stroke-width="4.67033"
      />
      <rect x="3" y="47" width="84" height="36" rx="4.98876" fill="white" />
      <rect
        x="10"
        y="53"
        width="30.7344"
        height="23"
        rx="2.49438"
        fill="#F25225"
      />
      <rect
        x="47"
        y="69"
        width="27.68"
        height="7"
        rx="2.49438"
        fill="#F25225"
      />
      <rect x="47" y="53" width="33" height="10" rx="2.49438" fill="#F25225" />
      <rect
        x="3"
        y="47"
        width="84"
        height="36"
        rx="4.98876"
        stroke="#F25225"
        stroke-width="4.67033"
      />
    </g>
    <defs>
      <clipPath id="clip0_1736_10613">
        <rect width="91" height="85" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
icons.downArrow = (
  <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 8.5L9.85714 13.5L5 8.77778"
      stroke="#222222"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
icons.upArrow = (
  <svg width="17" height="10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 11.5L9.85714 6.5L5 11.2222"
      stroke="#222222"
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
icons.productLock = (
  <svg
    width="25"
    height="32"
    viewBox="0 0 25 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.3333 10.6667H19.8095V7.61905C19.8095 3.41333 16.3962 0 12.1905 0C7.98476 0 4.57143 3.41333 4.57143 7.61905V10.6667H3.04762C1.37143 10.6667 0 12.0381 0 13.7143V28.9524C0 30.6286 1.37143 32 3.04762 32H21.3333C23.0095 32 24.381 30.6286 24.381 28.9524V13.7143C24.381 12.0381 23.0095 10.6667 21.3333 10.6667ZM12.1905 24.381C10.5143 24.381 9.14286 23.0095 9.14286 21.3333C9.14286 19.6571 10.5143 18.2857 12.1905 18.2857C13.8667 18.2857 15.2381 19.6571 15.2381 21.3333C15.2381 23.0095 13.8667 24.381 12.1905 24.381ZM16.9143 10.6667H7.46667V7.61905C7.46667 5.01333 9.58476 2.89524 12.1905 2.89524C14.7962 2.89524 16.9143 5.01333 16.9143 7.61905V10.6667Z"
      fill="#F25522"
    />
  </svg>
);
icons.replaceProduct = (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 1000 1000"
    enable-background="new 0 0 1000 1000"
  >
    <metadata> Svg Vector Icons : http://www.onlinewebfonts.com/icon </metadata>
    <g>
      <path d="M135.2,498.5c50.9,0,84.7-33.9,84.7-84.7l-0.2-26.7c0,0-12.6-75.8,88.5-75.8l409.3,2.8v108.1c19.8,19.8,52,19.8,71.9,0l158.1-158c19.8-19.9,19.8-52.1,0-71.9L789.3,24.8c-19.8-19.8-52-19.8-71.9,0v113.4c-9.9-2.9-396.5-4.5-396.5-4.5C92.9,133.7,43,282.9,43,343v63.4C43,457.2,84.3,498.5,135.2,498.5L135.2,498.5z" />
      <path d="M870.1,501.1c-50.9,0-92.2,35.9-92.2,86.8l0.1,58.8c-2.8,21.9-39.6,36.3-93.7,36.3H282.6l-0.1-95.8c-19.8-19.8-52-19.8-71.9,0l-158,158c-19.8,19.9-19.8,52.1,0,71.9l158,158c19.9,19.9,52.1,19.9,71.9,0l0.1-113.7h401.8c228,0,277.9-150.1,277.9-210.2v-63.4C962.3,536.9,921,501.1,870.1,501.1L870.1,501.1z" />
    </g>
  </svg>
);

export default icons;
